<form>
 <wd-field-text [title]="'Nome'"></wd-field-text>
 <wd-field-text [title]="'Cognome'"></wd-field-text>
 <wd-field-date [title]= "'Data di Nascita'" [value]="dataNascita"></wd-field-date>
</form>
